<template>
  <div>
    <div class="row">
      <div
        class="mt-4 mb-2 box"
        :class="className.sectionBlock"
        v-if="theme"
      ></div>

      <h4 class="mt-4 mb-2">{{ tableTitle }}</h4>
      <a
        @click="detailToggle()"
        role="button"
        class="btn btn-icon btn-sm  icon-collapse"
        :class="isShow ? 'btn-primary' : 'btn-default'"
      >
        <i :class="isShow ? 'icon-collapse_up' : 'icon-collapse_down'"></i>
      </a>
    </div>
    <div class="insurance-row row" v-show="isShow">
      <table
        :id="prefix"
        class="table datatable"
        :class="
          options.color === 'green' ? 'insurance-green' : 'insurance-blue'
        "
      >
        <thead>
          <tr>
            <th
              v-for="(item, index) in options.columns"
              :key="`table-tr-${index}`"
              :width="item.width || '*'"
              :class="{
                sorting: item.sorting,
                sorting_asc: item.sorting && order.index == index && order.asc,
                sorting_desc:
                  item.sorting && order.index == index && !order.asc,
                'text-right': item.align && item.align === 'right',
              }"
              @click="item.sorting ? columnSorting(item.name, index) : false"
            >
              <span v-html="item.label"></span>
            </th>
            <th class="no-sort" width="20" v-if="!editMode">展開<br />附約</th>
            <th class="no-sort" width="5%" v-else>編輯</th>
          </tr>
        </thead>

        <tbody v-if="tableLoading">
          <tr>
            <td colspan="12" class="text-center pt-3 pb-5">
              <h3>
                <div class="section-loading d-inline-block" style="height:20px; width:30px"></div>
                資料載入中
                <span>. . .</span>
              </h3>
            </td>
          </tr>
        </tbody>

        <tbody
          v-else
          v-for="(insure, i) in tableData"
          :key="`${prefix}-${i}`"
          :id="`${prefix}-tr-${i}`"
        >
          <!-- 主約保單顯示區塊 -->
          <tr
            v-show="!insure.onlySubIns && !insure.onlySubInsOther"
            :class="insure.focusOn ? 'bg-orange' : ''"
            :ref="i"
            :key="`${prefix}-col-tr-${i}`"
            :id="`${prefix}-col-tr-${i}`"
          >
            <td
              v-for="(col, cid) in options.columns"
              :class="{ 'text-right': col.align && col.align === 'right' }"
              :width="col.width || '*'"
              :key="`${prefix}-col-td-${i}-${cid}`"
              :id="`${prefix}-col-td-${i}-${cid}`"
            >
              <span v-if="prefix === 'cathay-insure' && col.name === 'no'">
                <a
                  v-if="!modalLoading && !insure.isSelfIns"
                  @click="col.click(insure, cid)"
                  class="link text-underline"
                  >{{ insure.no }}</a
                >
                <a
                  v-else-if="!modalLoading && insure.isSelfIns"
                  class="text-deepblue"
                  >{{ insure.no }}</a
                >
                <span v-else>{{ insure.no }}</span>
                <span class="spill-over ml-2" v-if="insure.spillOver == 'Y'">外溢</span>
                <div
                  :class="{ 'section-loading': modalLoading }"
                  class="d-inline-block"
                  style="height: 20px; width: 30px"
                ></div>
                <span class="text-red">{{ insure.scrt_ind }}</span>
                <br />
                {{ insure.name }}<span>({{ insure.prod_id }})</span>
                <div v-if="insure.ceplcvl">
                  <span style="color: #ffa500"
                    >保單價值：
                    {{ insure.d014_curr == "NTD" ? "" : insure.d014_curr }}
                    {{ Number(insure.ceplcvl) | numberFormat3 }}
                  </span>
                </div>
              </span>
              <span v-else-if="prefix === 'other-insure' && col.name === 'no'">
                <small>{{ insure.company }} / {{ insure.policynumber }}</small>
                <br />
                {{ insure.product }}
              </span>
              <span v-else-if="prefix === 'invalidPolicyInfo' && col.name === 'no'">
                <a
                  v-if="!modalLoading && !insure.isSelfIns"
                  @click="col.click(insure, cid)"
                  class="link text-underline"
                  >{{ insure.no }}</a
                >
                <a
                  v-else-if="!modalLoading && insure.isSelfIns"
                  class="text-deepblue"
                  >{{ insure.no }}</a
                >
                <span v-else>{{ insure.no }}</span>
                <br />
                {{ insure.name }}<span>({{ insure.prod_id }})</span>
                <div style="color: #ffa500" v-if="insure.job_id">
                  {{ getJobIdString(insure.job_id) }}
                </div>
              </span>
              <span
                v-else-if="col.template"
                v-html="col.template(insure)"
              ></span>
              <span
                v-else-if="prefix === 'cathay-insure' && col.name === 'target'"
              >
                <a
                  v-if="
                    insure.target_id &&
                    insure.target_id !== '' &&
                    insure.dataInsdExist == true
                  "
                  @click="col.click(insure, cid)"
                  class="link text-underline"
                  >{{ insure[col.name] }}</a
                >
                <span v-else>{{ insure[col.name] }}</span>
              </span>
              <span
                v-else-if="prefix === 'cathay-insure' && col.name === 'client'"
              >
                <a
                  v-if="
                    insure.clientId &&
                    insure.clientId !== '' &&
                    insure.dataAcpExist == true
                  "
                  @click="col.click(insure, cid)"
                  class="link text-underline"
                  >{{ insure[col.name] }}</a
                >
                <span v-else>{{ insure[col.name] }}</span>
              </span>
              <span
                v-else-if="prefix === 'invalidPolicyInfo' && col.name === 'target'"
              >
                <a
                  v-if="
                    insure.target_id &&
                    insure.target_id !== '' &&
                    insure.dataInsdExist == true
                  "
                  @click="col.click(insure, cid)"
                  class="link text-underline"
                  >{{ insure[col.name] }}</a
                >
                <span v-else>{{ insure[col.name] }}</span>
              </span>
              <span
                v-else-if="prefix === 'invalidPolicyInfo' && col.name === 'client'"
              >
                <a
                  v-if="
                    insure.clientId &&
                    insure.clientId !== '' &&
                    insure.dataAcpExist == true
                  "
                  @click="col.click(insure, cid)"
                  class="link text-underline"
                  >{{ insure[col.name] }}</a
                >
                <span v-else>{{ insure[col.name] }}</span>
              </span>
              <span
                v-else-if="
                  prefix === 'other-insure' && col.name === 'applicant'
                "
              >
                <a
                  v-if="insure.applicant_id && insure.applicant_id !== ''"
                  @click="col.click(insure, cid)"
                  class="link text-underline"
                  >{{ insure[col.name] }}</a
                >
                <span v-else>{{
                  _.isEmpty(insure[col.name]) ? "" : insure[col.name]
                }}</span>
              </span>
              <span
                v-else-if="prefix === 'other-insure' && col.name === 'fullname'"
              >
                <a
                  v-if="
                    insure.personalid &&
                    insure.personalid !== '' &&
                    insure.dataexist == true
                  "
                  @click="col.click(insure, cid)"
                  class="link text-underline"
                  >{{ insure[col.name] }}</a
                >
                <span v-else>{{ insure[col.name] }}</span>
              </span>
              <a
                v-else-if="col.click && insure.dataexist == true"
                @click="col.click(insure, cid)"
                class="link text-underline"
                >{{ insure[col.name] }}</a
              >
              <span v-else-if="prefix === 'cathay-insure-edit' && col.name === 'no'">
                <!--編輯保單/自行輸入國壽保單/主約-->
                <span class="text-deepblue">{{insure[col.name]}}</span>
                <br />
                {{insure.name}}({{insure.prod_id}})
              </span>
              <span v-else>{{ insure[col.name] }}</span>
            </td>
            <td v-show="!isEdit">
              <a
                role="button"
                class="btn btn-icon btn-default btn-sm btn-collapse"
                v-if="insure.child.length"
                :class="{
                  'is-open':
                    childStatus.length && childStatus[i] && childStatus[i].show,
                }"
                @click="toggleChild(insure, i)"
              >
                <i class="icon-collapse_down"></i>
              </a>
            </td>
            <td v-show="isEdit">
              <div class="dropdown" v-if="DeleteBtn == false">
                <a
                  :id="`${prefix}-${i}-dropdown`"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  v-if="insure.relatedtoprimaryinsured == '本人'"
                  aria-expanded="false"
                  class="btn btn-icon btn-default btn-sm"
                  role="button"
                >
                  <i class="icon-more"></i>
                </a>
                <div
                  class="dropdown-menu"
                  :aria-labelledby="`${prefix}-${i}-dropdown`"
                >
                  <a
                    role="button"
                    @click="
                      $emit(
                        'call',
                        'openInsureForm',
                        2,
                        false,
                        insure,
                        null,
                        true
                      );
                      cleanStorage();
                    "
                    class="dropdown-item text-green text-underline pointer-cursor"
                    >修改</a
                  >
                  <a
                      v-if="prefix === 'other-insure'"
                      role="button"
                      @click="$emit('call', 'openManualInputWindow', insure)"
                      class="dropdown-item text-green text-underline pointer-cursor"
                    >修改(新)</a>
                  <a
                    @click="
                      $emit('call', 'confirmClearInsurance', insure, true)
                    "
                    class="dropdown-item text-green text-underline pointer-cursor"
                    >刪除</a
                  >
                  <a
                    @click="
                      $emit(
                        'call',
                        'openInsureForm',
                        6,
                        true,
                        insure,
                        null,
                        true
                      );
                      cleanStorage();
                    "
                    class="dropdown-item text-green text-underline pointer-cursor"
                    >新增附約</a
                  >
                </div>
              </div>
              <div v-else class="text-center">
                <a
                  v-if="!insure.isSelfIns"
                  class="dropdown-item text-green text-underline"
                ></a>
                <a
                  v-else
                  @click="$emit('call', 'confirmCathayInsurance', insure, true)"
                  class="text-red text-underline pointer-cursor"
                  >刪除</a
                >
              </div>
            </td>
          </tr>

          <!-- 國泰壽險保單附約 -->
          <tr
            v-show="insure.child.length"
            class="child-table"
            :class="{
              show: isEdit || (childStatus.length && childStatus[i] && childStatus[i].show),
            }"
          >
            <td :colspan="options.columns.length + 1">
              <table class="table child">
                <tr
                  v-for="(child, chid) in insure.child"
                  :key="`${prefix}-tr-child-${chid}`"
                  :class="child.focusOn ? 'bg-orange' : ''"
                >
                  <td
                    v-for="(col, cid) in options.columns"
                    :class="{
                      'text-right': col.align && col.align === 'right',
                      child: cid === 0,
                    }"
                    :width="col.width || '*'"
                    :key="`${prefix}-col-${cid}`"
                  >
                    <span
                      v-if="prefix === 'cathay-insure' && col.name === 'no'"
                    >
                      {{ child.name }}<span>({{ child.prod_id }})</span>
                    <span class="spill-over ml-2" v-if="child.spillOver == 'Y'">外溢</span>
                    <div style="color: #ffa500" v-if="child.job_id">
                      {{ getJobIdString(child.job_id) }}
                    </div>
                    </span>
                    <span
                      v-else-if="prefix === 'invalidPolicyInfo' && col.name === 'no'"
                    >
                      {{ child.name }}<span>({{ child.prod_id }})</span>
                      <span class="spill-over ml-2" v-if="child.spillOver == 'Y'">外溢</span>
                      <div style="color: #ffa500" v-if="child.job_id">
                        {{ getJobIdString(child.job_id) }}
                      </div>
                    </span>
                    <span
                      v-else-if="prefix === 'other-insure' && col.name === 'no'"
                    >
                      <small
                        >{{ child.company }} / {{ child.policynumber }}</small
                      >
                      <br />
                      {{ child.product }}
                    </span>
                    <span
                      v-else-if="col.template"
                      v-html="col.template(child)"
                    ></span>
                    <span
                      v-else-if="
                        prefix === 'cathay-insure' && col.name === 'target'
                      "
                    >
                      <a
                        v-if="
                          child.target_id &&
                          child.target_id !== '' &&
                          child.dataInsdExist == true
                        "
                        @click="col.click(child, cid)"
                        class="link text-underline"
                        >{{ child[col.name] }}</a
                      >
                      <span v-else>{{ child[col.name] }}</span>
                    </span>
                    <span
                      v-else-if="
                        prefix === 'cathay-insure' && col.name === 'client'
                      "
                    >
                      <a
                        v-if="
                          child.clientId &&
                          child.clientId !== '' &&
                          child.dataAcpExist == true
                        "
                        @click="col.click(child, cid)"
                        class="link text-underline"
                        >{{ child[col.name] }}</a
                      >
                      <span v-else>{{ child[col.name] }}</span>
                    </span>
                    <span
                      v-else-if="
                        prefix === 'invalidPolicyInfo' && col.name === 'target'
                      "
                    >
                      <a
                        v-if="
                          child.target_id &&
                          child.target_id !== '' &&
                          child.dataInsdExist == true
                        "
                        @click="col.click(child, cid)"
                        class="link text-underline"
                        >{{ child[col.name] }}</a
                      >
                      <span v-else>{{ child[col.name] }}</span>
                    </span>
                    <span
                      v-else-if="
                        prefix === 'invalidPolicyInfo' && col.name === 'client'
                      "
                    >
                      <a
                        v-if="
                          child.clientId &&
                          child.clientId !== '' &&
                          child.dataAcpExist == true
                        "
                        @click="col.click(child, cid)"
                        class="link text-underline"
                        >{{ child[col.name] }}</a
                      >
                      <span v-else>{{ child[col.name] }}</span>
                    </span>
                    <span
                      v-else-if="
                        prefix === 'other-insure' && col.name === 'applicant'
                      "
                    >
                      <a
                        v-if="child.applicant_id && child.applicant_id !== ''"
                        @click="col.click(child, cid)"
                        class="link text-underline"
                        >{{ child[col.name] }}</a
                      >
                      <span v-else>{{
                        _.isEmpty(child[col.name]) ? "" : child[col.name]
                      }}</span>
                    </span>
                    <span
                      v-else-if="
                        prefix === 'other-insure' && col.name === 'fullname'
                      "
                    >
                      <a
                        v-if="
                          child.personalid &&
                          child.personalid !== '' &&
                          child.dataexist == true
                        "
                        @click="col.click(child, cid)"
                        class="link text-underline"
                        >{{ child[col.name] }}</a
                      >
                      <span v-else>{{ child[col.name] }}</span>
                    </span>
                    <!-- <span v-else-if="prefix==='other-insure' && col.name==='beneficiary'">
                                            <div v-for="(ben, bid) in child.beneficiary" :key="`${prefix}-col-${bid}-beneficiary`">
                                                <span v-html="ben"></span>
                                            </div>
                                        </span> -->
                    <a
                      v-else-if="col.click && child.dataexist == true"
                      @click="col.click(child, cid)"
                      class="link text-underline"
                      >{{ child[col.name] }}</a
                    >
                    <span v-else-if="prefix === 'cathay-insure-edit' && col.name === 'no'">
                      <!--編輯保單/自行輸入國壽保單/附約-->
                      {{ child.name }}<span>({{ child.prod_id }})</span>
                    </span>
                    <span v-else>{{ child[col.name] }}</span>
                  </td>
                  <td>
                    <div
                      class="dropdown"
                      v-show="DeleteBtn == false"
                      :style="{ visibility: isEdit ? '' : 'hidden' }"
                    >
                      <a
                        :id="`child-${i}-dropdown`"
                        data-toggle="dropdown"
                        aria-haspopup="true"
                        v-if="child.relatedtoprimaryinsured == '本人'"
                        aria-expanded="false"
                        class="btn btn-icon btn-default btn-sm"
                        role="button"
                      >
                        <i class="icon-more"></i>
                      </a>
                      <div
                        class="dropdown-menu"
                        :aria-labelledby="`child-${i}-dropdown`"
                      >
                        <a
                          role="button"
                          @click="
                            $emit(
                              'call',
                              'openInsureForm',
                              6,
                              false,
                              child,
                              insure,
                              true
                            );
                            cleanStorage();
                          "
                          class="dropdown-item text-green text-underline pointer-cursor"
                          >修改</a
                        >
                        <a
                          v-if="prefix === 'other-insure'" role="button"
                          @click="$emit('call', 'openManualInputWindow', child)"
                          class="dropdown-item text-green text-underline pointer-cursor"
                        >修改(新)</a
                      >
                        <a
                          @click="
                            $emit('call', 'confirmClearInsurance', child, false)
                          "
                          class="dropdown-item text-green text-underline pointer-cursor"
                          >刪除</a
                        >
                      </div>
                    </div>
                  </td>
                </tr>
              </table>
            </td>
          </tr>

          <!-- 國泰壽險沒有主約的附約 -->
          <tr class="child-table show onlySub" v-if="insure.onlySubIns">
            <td :colspan="options.columns.length + 1">
              <table class="table child">
                <tr>
                  <td
                    v-for="(col, cid) in options.columns"
                    :class="{
                      'text-right': col.align && col.align === 'right',
                      'sub-child': cid === 0,
                    }"
                    :width="getClientWidth(i, cid)"
                    :key="`${prefix}-sub-col-${cid}`"
                  >
                    <span
                      v-if="prefix === 'cathay-insure' && col.name === 'no'"
                    >
                      <span
                        v-if="insure.onlySubInsSelf"
                        class="text-deepblue"
                        >{{ insure.no }}</span
                      >
                      <span v-else>{{ insure.no }}</span
                      >
                      <br />
                      <div class="pl-4 inline-block">{{ insure.name }}<span v-if="insure.onlySubInsSelf">({{ insure.prod_id }})</span></div>
                      <div style="color: #ffa500" v-if="insure.job_id">
                        {{ getJobIdString(insure.job_id) }}
                      </div>
                    </span>

                    <span
                      v-else-if="col.template"
                      v-html="col.template(insure)"
                    ></span>
                    <span
                      v-else-if="
                        col.click &&
                        prefix === 'cathay-insure' &&
                        col.name === 'target'
                      "
                    >
                      <a
                        v-if="insure.target_id && insure.target_id !== ''"
                        @click="col.click(insure, cid)"
                        class="link text-underline"
                        >{{ insure[col.name] }}</a
                      >
                      <span v-else>{{ insure[col.name] }}</span>
                    </span>
                    <span
                      v-else-if="
                        col.click &&
                        prefix === 'cathay-insure' &&
                        col.name === 'client'
                      "
                    >
                      <a
                        v-if="insure.clientId && insure.clientId !== ''"
                        @click="col.click(insure, cid)"
                        class="link text-underline"
                        >{{ insure[col.name] }}</a
                      >
                      <span v-else>{{ insure[col.name] }}</span>
                    </span>
                    <span v-else-if="prefix === 'cathay-insure-edit' && col.name === 'no'">
                      <!--編輯保單/自行輸入國壽保單/只有附約-->
                      <span
                        v-if="insure.onlySubInsSelf"
                        class="text-deepblue"
                        >{{ insure.no }}</span
                      >
                      <span v-else>{{ insure.no }}</span
                      ><br />
                      <div class="pl-4 inline-block">{{ insure.name }}({{ insure.prod_id }})</div>
                    </span>
                    <a
                      v-else-if="col.click"
                      @click="col.click(insure, cid)"
                      class="link text-underline"
                      >{{ insure[col.name] }}</a
                    >
                    <span v-else>{{ insure[col.name] }}</span>
                  </td>
                  <td :width="getClientWidth(i, options.columns.length)">
                    <a v-if="isEdit && insure.onlySubInsSelf"
                      @click="$emit('call', 'confirmCathayInsurance', insure, false)"
                       class="text-red text-underline pointer-cursor"
                      >
                      刪除
                    </a>
                  </td>
                </tr>
              </table>
            </td>
          </tr>
          <!-- 同業壽險沒有主約的附約 -->
          <tr
            class="child-table show onlySubOther"
            style="backgron"
            v-if="insure.onlySubInsOther"
          >
            <td :colspan="options.columns.length + 1">
              <table class="table child">
                <tr>
                  <td
                    v-for="(col, cid) in options.columns"
                    :class="{
                      'text-right': col.align && col.align === 'right',
                      'sub-child': cid === 0,
                    }"
                    :width="getClientWidth(i, cid)"
                    :key="`${prefix}-sub-col-${cid}`"
                  >
                    <span v-if="prefix === 'other-insure' && col.name === 'no'">
                      <span
                        >>{{ insure.company }} / {{ insure.policynumber }}</span
                      ><br />
                      <div class="pl-4 inline-block">{{ insure.product }}</div>
                    </span>

                    <span
                      v-else-if="col.template"
                      v-html="col.template(insure)"
                    ></span>
                    <span
                      v-else-if="
                        prefix === 'other-insure' && col.name === 'fullname'
                      "
                    >
                      <a
                        v-if="insure.personalid && insure.personalid !== ''"
                        @click="col.click(insure, cid)"
                        class="link text-underline"
                        >{{ insure[col.name] }}</a
                      >
                      <span v-else>{{ insure[col.name] }}</span>
                    </span>
                    <span
                      v-else-if="
                        prefix === 'other-insure' && col.name === 'applicant'
                      "
                    >
                      <a
                        v-if="insure && insure.applicant_id"
                        @click="col.click(insure, cid)"
                        class="link text-underline"
                        >{{ insure[col.name] }}</a
                      >
                      <span v-else>{{
                        _.isEmpty(insure[col.name]) ? "" : insure[col.name]
                      }}</span>
                    </span>
                    <a
                      v-else-if="col.click"
                      @click="col.click(insure, cid)"
                      class="link text-underline"
                      >{{ insure[col.name] }}</a
                    >
                    <span v-else>{{ insure[col.name] }}</span>
                  </td>
                  <td :width="getClientWidth(i, options.columns.length)">
                    <div v-if="isEdit">
                      <div class="dropdown" v-if="DeleteBtn == false">
                        <a
                          :id="`${prefix}-${i}-dropdown`"
                          data-toggle="dropdown"
                          aria-haspopup="true"
                          v-if="insure.relatedtoprimaryinsured == '本人'"
                          aria-expanded="false"
                          class="btn btn-icon btn-default btn-sm"
                          role="button"
                        >
                          <i class="icon-more"></i>
                        </a>
                        <div
                          class="dropdown-menu"
                          :aria-labelledby="`${prefix}-${i}-dropdown`"
                        >
                          <a
                            role="button"
                            @click="$emit('call', 'openInsureForm', 6, false, insure, null, true); cleanStorage();"
                            class="dropdown-item text-green text-underline pointer-cursor"
                          >修改</a>
                          <a
                            v-if="prefix === 'other-insure'" role="button"
                            @click="$emit('call', 'openManualInputWindow', insure)"
                            class="dropdown-item text-green text-underline pointer-cursor"
                          >修改(新)</a>                         
                          <a
                            @click="$emit('call', 'confirmClearInsurance', insure, false)"
                            class="dropdown-item text-green text-underline pointer-cursor"
                          >刪除</a>
                        </div>
                      </div>
                    </div>
                  </td>
                </tr>
              </table>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { commonMixin } from "../../mixins/common";
import { setTimeout } from "timers";
import { debuglog } from "util";

export default {
  name: "DataTable",
  mixins: [commonMixin],
  props: {
    collapse: {
      type: Boolean,
      default: false,
    },
    editMode: {
      type: Boolean,
      default: false,
    },
    color: {
      type: String,
      default: "green",
    },
    prefix: {
      type: String,
      default: "",
    },
    tableTitle: {
      type: String,
      default: "",
    },
    currentPage: {
      type: Number,
      default: 0,
    },
    totalpages: {
      type: Number,
      default: 0,
    },
    scrollDataLoading: {
      type: Boolean,
      default: false,
    },
    tableData: {
      type: Array,
      default: () => {
        return [];
      },
    },
    options: {
      type: Object,
      default: () => {
        return null;
      },
    },
    isEdit: {
      type: Boolean,
      default: false,
    },
    modalLoading: {
      type: Boolean,
      default: false,
    },
    tableLoading: {
      type: Boolean,
      default: false,
    },
    DeleteBtn: {
      type: Boolean,
      default: false,
    },
    checkPersonalId: {
      type: Boolean,
      default: false,
    },
    theme: {
      type: String,
      default: "",
    },
    unitExist: {
      type: Boolean,
      default: false,
    }
  },
  computed: {
    ...mapGetters(["BaseUrl"]),
    baseLink() {
      return `${window.location.origin}${window.location.pathname}`;
    },
    className() {
      switch (this.theme) {
        case "red":
          return {
            sectionBlock: "boxRed",
          };
        case "blue":
          return {
            sectionBlock: "boxBlue",
          };
        case "green":
          return {
            sectionBlock: "boxGreen",
          };
      }
    },
  },
  data() {
    return {
      tableList: this.tableData,
      order: {},
      remoteDataMsg: "資料讀取中，請稍候...",
      childStatus: [],
      isShow: true,
    };
  },
  watch: {
    tableData: "initData",
    collapse: "toggleAll",
  },
  methods: {
    getClientWidth(i, index) {
      if (!this.childStatus.length) return;
      let $th = Array.from(this.$el.querySelectorAll("th"));
      return $th[index].getBoundingClientRect().width;
    },
    initData() {
      this.tableData.forEach((insure, i) => {
        this.childStatus[i] = {
          render: false,
          show: false,
        };
      });
      if (this.isEdit) {
        setTimeout(() => this.toggleAll(true));
      }
    },
    toggleAll(val) {
      this.tableData.forEach((insure, i) => {
        if (this.childStatus[i].show !== val) this.toggleChild(insure, i);
      });
    },
    toggleChild(insure, i) {
      this.childStatus[i].show = !this.childStatus[i].show;
      this.$forceUpdate();
    },
    columnSorting(colName, index) {
      // 資料排序
      if (this.order.index === index) {
        this.order.asc = !this.order.asc;
      } else {
        this.order.index = index;
        this.order.asc = true;
      }
      this.options.sorting(colName, this.order.asc);
    },
    cleanStorage() {
      localStorage.otherDifference = "";
    },
    detailToggle() {
      this.isShow = !this.isShow;
    },
    getJobIdString(job_id) {
      switch(job_id) {
        case "1" :
          return "職業類別 : 第１類";
        case "2" :
          return "職業類別 : 第２類";
        case "3" :
          return "職業類別 : 第３類";
        case "4" :
          return "職業類別 : 第４類";
        case "5" :
          return "職業類別 : 第５類";
        case "6" :
          return "職業類別 : 第６類";
        default:
        return "";
      }
    }
  },
  mounted() {
    this.initData();
  },
};
</script>

<style lang="scss" scoped>
.table tbody tr.bg-orange {
  background: #feeedd;
}
tr.child > td {
  padding: 0;
}
tr.child-table {
  display: none;
  &.show {
    width: 100%;
    display: table-row;
    &.onlySubOther {
      background: transparentize(#007ab1, 0.9);
    }
  }
}
.icon-collapse {
  margin-block-start: 1.6em;
  margin-bottom: 0.45rem;
  font-size: 15px;
}
.box {
  float: left;
  height: 24px;
  width: 8px;
  margin-right: 8px;
  clear: both;
}
.boxGreen {
  background-color: #027a39;
}
.boxBlue {
  background-color: #007ab1;
}
.boxRed {
  background-color: #de4054;
}
.spill-over {
  color: #fff;
  background-color: #027a39;
  border-radius: 3px;
  padding: 1px;
  font-size: 14px;
  display: inline-block;
  margin-bottom: 2px;
}
</style>
